export enum LiverLeagueLevel {
  OFFICIAL = 1,
  CLOVER_TWO = 2,
  CLOVER_ONE = 3,
}

export interface LiverLeague {
  name: string;
  level?: LiverLeagueLevel;
  type?: string;
  link?: string;
  isRookies?: boolean;
}
